<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col cols="10" class="mx-auto mb-3">
        <h1 class="my-5 main-title">
          Escritório de Privacidade
        </h1>

        <h2 class="section-title">
          O que é
        </h2>
        <p class="main-text">
          O <strong>Escritório de Privacidade</strong> é responsável por
          gerenciar a <strong>Política de Privacidade</strong> da CASSEMS, para
          efeitos de aplicação da
          <em>Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709, de 14 de
            agosto de 2018)</em>
          no âmbito da Instituição.
        </p>

        <h2 class="section-title">
          Equipe
        </h2>
        <p class="main-text">
          O Escritório é liderado pelo
          <strong>DPO (Data Protection Officer)</strong>, também conhecido como
          Encarregado de Tratamento de Dados Pessoais, e conta com uma equipe
          que inclui uma Analista e uma Assistente de Privacidade e Proteção de
          Dados, além de um suporte externo especializado na área.
        </p>

        <h2 class="section-title">
          Compromisso
        </h2>
        <p class="main-text">
          Nosso compromisso é estabelecer um sistema voltado à proteção dos
          dados pessoais gerados e utilizados na CASSEMS, o que envolve a
          criação de diretrizes para adequação à
          <strong>Lei Geral de Proteção de Dados – LGPD</strong>.
        </p>

        <h2 class="section-title">
          Principais Atribuições
        </h2>
        <v-card class="pa-4 highlight-box" outlined>
          <v-list dense>
            <v-list-item
              v-for="(item, index) in atribuicoes"
              :key="index"
              class="py-2"
            >
              <v-list-item-icon>
                <v-icon color="#173C94">
                  mdi-check-circle-outline
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="10" class="mx-auto mb-3">
        <img
          src="@/assets/privacy_office.webp"
          width="100%"
          alt="Imagem do Escritório de Privacidade da Cassems com informações gerais e imagem do Encarregado de Dados Pessoais, Guilherme Victorino"
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PrivacyOffice",
  data() {
    return {
      atribuicoes: [
        "Zelar pela proteção de dados pessoais na CASSEMS;",
        "Promover uma cultura de privacidade por meio de capacitações e treinamentos periódicos a todos os colaboradores;",
        "Desenvolver, revisar e implementar políticas e procedimentos relacionados à privacidade e proteção de dados;",
        "Orientar as unidades e hospitais da CASSEMS na interpretação e aplicação das normas e regulamentos da LGPD.",
      ],
    };
  },
};
</script>

<style scoped>
.main-title {
  font-size: 2rem;
  font-weight: 700;
  color: #173c94;
}

.section-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #173c94;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
}

.main-text {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #333;
  margin-bottom: 1.2rem;
}

.highlight-box {
  background-color: #f5f8ff;
  border-left: 4px solid #173c94;
  border-radius: 8px;
}


.v-list-item__title {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: clip !important;
  word-break: break-word !important;
}
</style>
